/**
 * Feather Icons Utility
 * Initializes and refreshes Feather icons
 */

export function initFeatherIcons() {
    if (typeof feather !== 'undefined') {
        feather.replace();
    }
}
